// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__Tg14C","title":"InfoRow_title__1kZGU"};